import { useEffect, useState } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { api, qs } from '../api'
import WarehouseCard from '../components/WarehouseCard'
import WarehouseMap from '../components/WarehouseMap'
import type { ReferenceData, Warehouse } from '../types'

export default function HomePage() {
  const [params,setParams] = useSearchParams()
  const [refs,setRefs] = useState<ReferenceData|null>(null)
  const [items,setItems] = useState<Warehouse[]>([])
  const [total,setTotal] = useState(0)
  const [loading,setLoading] = useState(true)
  const [view,setView] = useState<'list'|'map'>('list')
  const filters = {
    q: params.get('q') || '', region: params.get('region') || '', city: params.get('city') || '',
    marketplace: params.get('marketplace') || '', category: params.get('category') || '', scheme: params.get('scheme') || 'FBS'
  }
  useEffect(() => { api<ReferenceData>('/api/public/reference-data').then(setRefs).catch(console.error) },[])
  useEffect(() => {
    setLoading(true)
    api<{items:Warehouse[];total:number}>(`/api/public/warehouses?${qs({...filters,limit:100})}`)
      .then(r => {setItems(r.items);setTotal(r.total)}).catch(console.error).finally(()=>setLoading(false))
  },[params.toString()])
  function update(key:string,value:string) {
    const next = new URLSearchParams(params)
    value ? next.set(key,value) : next.delete(key)
    setParams(next)
  }
  return <>
    <section className="hero">
      <div className="container hero-grid">
        <div>
          <div className="eyebrow">Фулфилменты по всей России</div>
          <h1>Найдите склад, который примет товар и вовремя отгрузит FBS</h1>
          <p>Сравнивайте актуальные мощности, цены, маршруты отгрузки, автоматизацию и ответственность за товар.</p>
          <div className="hero-actions"><Link className="button" to="/seller/request">Получить предложения</Link><Link className="button secondary" to="/dashboard">Добавить фулфилмент</Link></div>
        </div>
        <div className="hero-panel">
          <b>Что проверяем</b>
          <ul><li>Свободные мощности сейчас</li><li>Полную стоимость FBS</li><li>График и точки отгрузки</li><li>WMS и синхронизацию остатков</li><li>Договор и ответственность</li></ul>
        </div>
      </div>
    </section>
    <main className="container catalog-layout" id="catalog">
      <aside className="filters-panel">
        <h2>Подбор фулфилмента</h2>
        <label>Поиск<input value={filters.q} onChange={e=>update('q',e.target.value)} placeholder="Название или город"/></label>
        <label>Регион<input value={filters.region} onChange={e=>update('region',e.target.value)} placeholder="Например, Московская область"/></label>
        <label>Город<input value={filters.city} onChange={e=>update('city',e.target.value)} placeholder="Москва"/></label>
        <label>Маркетплейс<select value={filters.marketplace} onChange={e=>update('marketplace',e.target.value)}><option value="">Все</option>{refs?.marketplaces.map(i=><option key={i.code} value={i.code}>{i.title}</option>)}</select></label>
        <label>Схема<select value={filters.scheme} onChange={e=>update('scheme',e.target.value)}><option value="">Все</option>{refs?.schemes.map(i=><option key={i.code} value={i.code}>{i.title}</option>)}</select></label>
        <label>Категория<select value={filters.category} onChange={e=>update('category',e.target.value)}><option value="">Все категории</option>{refs?.categories.map(i=><option key={i.code} value={i.code}>{i.title}</option>)}</select></label>
        <button className="link-button" onClick={()=>setParams({scheme:'FBS'})}>Сбросить фильтры</button>
      </aside>
      <section className="catalog-content">
        <div className="catalog-toolbar"><div><h2>Работающие фулфилменты</h2><span>{loading ? 'Загрузка…' : `Найдено: ${total}`}</span></div><div className="segmented"><button className={view==='list'?'active':''} onClick={()=>setView('list')}>Список</button><button className={view==='map'?'active':''} onClick={()=>setView('map')}>Карта</button></div></div>
        {view==='map' ? <WarehouseMap items={items}/> : <div className="warehouse-grid">{items.map(i=><WarehouseCard key={i.id} item={i}/>)}</div>}
        {!loading && items.length===0 && <div className="empty"><h3>Пока ничего не найдено</h3><p>Оставьте заявку — подходящие фулфилменты смогут сами предложить условия.</p><Link className="button" to="/seller/request">Создать заявку</Link></div>}
      </section>
    </main>
  </>
}
